import { SAMPLE_DATA_LOADING, SAMPLE_DATA_LOADED, SAMPLE_DATA_ERROR, SAMPLE_PRIMARY_TOGGLE, SAMPLE_FILTER_APPLY, SAMPLE_SEARCH, SERVICE_HEADER } from "./Consts";
import axios from "axios";
import { booksListParser, parseFilterKeys } from "../utils/parser";
import Config from "../config/Configs";

export const fetchInitialData = (isPrimary = false) => {
    return (dispatch) => {
        dispatch({
            type: SAMPLE_DATA_LOADING
        });
        
        // "/data/data1.json"
            axios.post(Config.sampleBookService, "",{headers: SERVICE_HEADER})
        // axios.get("/data/data1.json", "",{headers: headers})
            .then((responce) => {
                const key = isPrimary ? "primary" : "secondary"
                const books = booksListParser(responce.data.books);
                const renderingList = books.indexes.catergories[key]|| [];
                const filters = parseFilterKeys(books.indexes);
                dispatch({
                    type: SAMPLE_DATA_LOADED,
                    payload: { 
                        books, 
                        renderingList,
                        filters
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                dispatch({
                    type: SAMPLE_DATA_ERROR,
                    payload: { errorMsg: err.message }
                })
            })
    }
}

export const togglePrimary = (view) => {
    return (dispatch, getState) =>{
        const state = getState()
        const {books} = state.SamplePage
        const renderingList = books.indexes.catergories[view] || [];
        dispatch({
            type: SAMPLE_PRIMARY_TOGGLE,
            payload: {renderingList }
        })}
    }

export const applyFilter = ({year = "", subject = "", state = ""}) => {
    return (dispatch, getState) => {
        const appState = getState();
        const filter = {...appState.SamplePage.filter}
        const indexes = appState.SamplePage.books.indexes
        const secBooks = indexes.catergories["secondary"] ||[]
        filter.value = {
            year, state, subject
        }
        const filterYears = year === "" ? secBooks : indexes.years[year];
        const filterState = state === "" ? secBooks : indexes.states[state];
        const filterSubject = subject === "" ? secBooks : indexes.subjects[subject];
        let renderingList = filterYears.filter(x => filterState.includes(x));
            renderingList = renderingList.filter(x => filterSubject.includes(x));
        
        dispatch({
            type:SAMPLE_FILTER_APPLY,
            payload:{
                filter,
                renderingList
            }
        })
        
    };
};

export const searchInSample = (searchKey) => {
    console.log(searchKey);
    return (dispatch, getState) => {
        const appState = getState();
        const books = appState.SamplePage.books;
        const lastList = appState.SamplePage.lastDisplayList;
        let renderingList = lastList.filter(el=>{
            const book = books[el];
            if(
               book.title.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0 ||
               book.author.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0 || 
               book.bookmeta.subject.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0 || 
               book.allISBNs.toLowerCase().indexOf(searchKey.toLowerCase()) >= 0 
            ) {
                return true
            }
            return false;       
        })
        
        console.log(renderingList);
        dispatch({
            type:SAMPLE_SEARCH,
            payload :{searchKey, renderingList}
        })
    };
};
